import { Component } from 'react'
import styled from 'glamorous'
import { withRouter } from 'react-router-dom'
import Route from 'react-router-dom/Route'
import Switch from 'react-router-dom/Switch'
import { graphql, compose } from 'react-apollo'
import filter from 'lodash/filter'
import map from 'lodash/map'
import range from 'lodash/range'

import { $, getLocationQuery, getUrlSearch, getError } from 'utils'
import { Button, InnerLayout, PaginationBar, EmptyLayout, EmptyDetails, Loader, FileButton } from 'components'
import { PERSONS as query, CreatePersonMutation } from 'queries'
import { withConsumer } from 'store'
import { client } from 'config'

import PersonsList from './PersonsList'
import DetailsPage from './DetailsPage'


const Header = styled.div({
  display: 'flex',
  justifyContent: 'space-between'
})

const HeaderButtons = styled.div({
  display: 'flex'
})

const AddContainer = styled.div({
  position: 'relative',
  display: 'flex',
  justifyContent: 'flex-end',
  marginLeft: 10,
  '& > *:not(:last-child)': {
    marginRight: 10,
  },
})

export class Persons extends Component {

  addBatch = () => {
    const formData = new FormData()
    const arr = []
    arr.map.call(this.input.files, file => formData.append('file', file))
    return fetch(`/extract/batch`, {
      method: 'POST',
      credentials: 'same-origin',
      body: formData,
    })
      .then(response => {
        response.json().then(data => {
          const { persons } = data
          const variables = getVariables(getLocationQuery(this.props.location))
          const cacheData = client.cache.readQuery({ query, variables })
          cacheData.persons.items = [
            ...persons.reverse().map(person => ({
              __typename: "Person",
              uuid: person.id,
              userData: person.user_data,
              externalId: '',
              portrait: person.portrait,
              descriptors: map(person.descriptors.reverse(), descriptor => ({
                uuid: descriptor.id,
                portrait: `/portrait/${descriptor.id}`,
                __typename: "Descriptor"
              }))
            })),
            ...cacheData.persons.items
          ]
          cacheData.persons.items = filter(cacheData.persons.items, (item, i) => i < variables.limit)
          cacheData.persons.count = cacheData.persons.count + persons.length
          client.cache.writeQuery({ query, data: cacheData, variables })
          client.queryManager.broadcastQueries()
          this.props.setErrorMessage(`${persons.length} persons out of ${this.input.files.length} photos successfully created`)
        })
      })
  }

  createPerson = () => this.props.mutate({
    variables: { userData: '' },
    update: (proxy, { data: { createPerson } }) => {
      const variables = getVariables(getLocationQuery(this.props.location))
      const data = proxy.readQuery({ query, variables })
      data.persons.items = [{
          __typename: "Person",
          uuid: createPerson.personId,
          userData: createPerson.userData,
          externalId: '',
          portrait: null,
          descriptors: []
        },
        ...data.persons.items
      ]
      data.persons.items = filter(data.persons.items, (item, i) => i < variables.limit)
      data.persons.count = data.persons.count + 1
      proxy.writeQuery({ query, data, variables })
    }
  }).then(({ data }) => this.props.history.push({
    pathname: `/persons/${data.createPerson.personId}`,
    search: window.location.search
  }))
    .catch(error => this.props.setErrorMessage(getError(error)))

  changePage = (value) => {
    const { history, location, data: { variables: vars } } = this.props
    const search = getUrlSearch({...vars, offset: value})
    history.push({
      pathname: location.pathname,
      search,
    })
  }

  render = () => {
    const { data: { persons, loading, variables: vars } } = this.props
    if (loading && !persons) return $(Loader)
    const pagesCount = persons ? Math.ceil(persons.count / (vars.limit || 5)) : 0
    const paginationOptions = range(1, pagesCount + 1)

    return (
      persons.items.length > 0
        ? $(InnerLayout,
          $(Header,
            $(PaginationBar, {
              name: 'Persons',
              options: paginationOptions,
              value: vars.offset || 1,
              onChange: this.changePage,
              from: pagesCount,
            }),
            $(HeaderButtons,
              // $(Select, {
              //   value,
              //   options,
              //   onChange: noop,
              //   width: '330px',
              //   clearable: false,
              //   searchable: false
              // }),
              $(AddContainer,
                $(FileButton, {
                  fileRef: input => this.input = input,
                  multiple: true,
                  onChange: this.addBatch,
                  buttonProps: {
                    bgColor: 'var(--violet)',
                    width: 165,
                    text: 'Batch add persons',
                  }
                }),
                $(Button, {
                  bgColor: 'var(--violet)',
                  width: 165,
                  primary: true,
                  onClick: this.createPerson,
                }, 'Add person'),
              ),
            ),
          ),
          $(Switch,
            $(Route, {
              path: `/persons/:id?`,
              render: () =>
                $(PersonsList, { persons }),
            })
          ),
          $(Switch,
            $(Route, {
              path: `/persons/:id`,
              render: () => $(DetailsPage)
            }),
            $(Route, {
              path: `/persons`,
              component: EmptyDetails
            }),
          )
        )
        : $(EmptyLayout, {
            title: 'There are no persons yet',
            icon: 'personsEmpty',
            loading
          },
            $(Button, {
              bgColor: 'var(--violet)',
              width: 124,
              primary: true,
              onClick: this.createPerson,
            }, 'Add person'),
          )
    )
  }
}

export default withRouter(
  compose(
    graphql(CreatePersonMutation),
    graphql(query, {
      options: props => {
        const queryParams = getLocationQuery(props.location)
        return {
          fetchPolicy: 'cache-and-network',
          variables: getVariables(queryParams)
        }
      }
    })
  )(withConsumer(Persons, '/persons'))
)

const getVariables = (queryParams) => ({
    limit: +queryParams.limit || 5,
    offset: +queryParams.offset || 1,
})



// WEBPACK FOOTER //
// ./src/pages/Persons/index.js